// extracted by mini-css-extract-plugin
export default {"privacy-policy":"PrivacyPolicyCSS_privacy-policy__B4r0-"};